import React from 'react';

import _ from 'lodash';

import { useGetAdminFavoriteCodesQuery } from '../../../apis/AdminApi';
import { useGetFavoriteCodesQuery } from '../../../apis/CommonApi';
import { SelectorType } from '../../../types/SelectorType';
import { CurrentUser, User } from '../../../types/User';

import SavedCodeCellAdmin from './SavedCodeCellAdmin';
import SavedCodeCellFlorence from './SavedCodeCellFlorence';

type Props = {
  user: CurrentUser | User;
  type: 'admin' | 'florence';
  renderLoadingSpinner: () => JSX.Element;
  renderNoRecordsText: (type: SelectorType) => JSX.Element;
  renderNoSubscriptionText: (type: SelectorType) => JSX.Element;
};

const SavedCodesContainer: React.FC<Props> = ({
  user,
  type,
  renderLoadingSpinner,
  renderNoRecordsText,
  renderNoSubscriptionText,
}) => {
  const { data: savedCodes, isLoading: savedCodesIsLoading } =
    useGetFavoriteCodesQuery(undefined, {
      skip: type === 'admin',
      refetchOnFocus: true,
      refetchOnMountOrArgChange: 60,
    });

  const { data: adminSavedCodes, isLoading: adminSavedCodesIsLoading } =
    useGetAdminFavoriteCodesQuery(user.id.toString(), {
      skip: type === 'florence',
      refetchOnFocus: true,
      refetchOnMountOrArgChange: 60,
    });

  if (savedCodesIsLoading || adminSavedCodesIsLoading || !user) {
    return renderLoadingSpinner();
  }

  if (_.isEmpty(type === 'florence' ? savedCodes : adminSavedCodes)) {
    return renderNoRecordsText('Codes');
  }

  if (
    type === 'florence' &&
    !user.activeSubscriptionType &&
    !user.organizationId
  ) {
    return renderNoSubscriptionText('Codes');
  }

  const shouldReturnFewer = () => {
    return (
      user.activeSubscriptionType === 'mobile' ||
      user.activeSubscriptionType === 'trial'
    );
  };

  const codeData = shouldReturnFewer()
    ? _.slice(savedCodes, 0, 10)
    : savedCodes;

  return (
    <>
      {type === 'florence' ? (
        <>
          {codeData?.map((code) => (
            <SavedCodeCellFlorence key={code.id} code={code} />
          ))}
        </>
      ) : (
        <>
          {adminSavedCodes?.map((code) => (
            <SavedCodeCellAdmin key={code.id} code={code} />
          ))}
        </>
      )}
    </>
  );
};

export default SavedCodesContainer;
